import { Col, Container, Row } from 'react-bootstrap';
import { Card } from 'shared/components';
import { PageTitle } from 'shared/components/Fonts';
import { useForm, FormProvider } from 'react-hook-form';
import { useMemo } from 'react';
import { useAuth } from 'auth/hooks/useAuth';
import { canAccessReportOption } from '../../util/reportPermissions';
import { MovimientosPorTarjetaForm } from '../../components/MovimientosPorTarjetaForm/MovimientosPorTarjetaForm';
import { RendicionPorCentroCostoFrom } from '../../components/RendicionPorCentroCostoForm/RendicionPorCentroCostoForm';
import { UltimasLiquidacionesPage } from '../UltimasLiquidacionesPage/UltimasLiquidacionesPage';
import { UltimasLiquidacionesProvider } from '../../contexts/UltimasLiquidacionesContext';
import { ControlledSelect } from 'shared/form/components/ControlledSelect';
import { MovimientosLiquidadosForm } from 'core/reporte/components/MovimientosLiquidadosForm/MovimientosLiquidadosForm';

interface ReportOption {
  value: string;
  label: string;
}

const BASE_REPORT_OPTIONS: ReportOption[] = [
  { value: '', label: 'Seleccione...' },
  { value: 'movimientos-por-tarjeta', label: 'Movimientos por tarjeta' },
  { value: 'rendicion-por-centro-de-costo', label: 'Rendición por Centro de Costo' },
  { value: 'ultimas-liquidaciones', label: 'Ultimas liquidaciones' },
  { value: 'movimientos-liquidados', label: 'Movimientos liquidados' },
];

export const ConsultarReportePage = () => {
  const { user } = useAuth();

  const reportOptions = useMemo(() => {
    const funcionalidades = user?.funcionalidades || [];
    return BASE_REPORT_OPTIONS.filter((option) =>
      canAccessReportOption(funcionalidades, option.value),
    );
  }, [user?.funcionalidades]);

  const methods = useForm({
    defaultValues: {
      reportType: reportOptions[0],
    },
  });

  const reportTypeSelection = methods.watch('reportType');
  const reportType = reportTypeSelection?.value ?? '';

  return (
    <Container fluid>
      <Row className="mb-3 d-flex justify-content-between align-items-center">
        <Col>
          <PageTitle>Consultar Reporte</PageTitle>
        </Col>
      </Row>

      <Card className="mb-4">
        <Card.Title>Reporte</Card.Title>
        <Card.Body $padding>
          <Row>
            <FormProvider {...methods}>
              <form>
                <Col>
                  <ControlledSelect
                    name="reportType"
                    label="Tipo de reporte"
                    options={reportOptions}
                  />
                </Col>
              </form>
            </FormProvider>
          </Row>
        </Card.Body>
      </Card>

      {reportType === 'ultimas-liquidaciones' && (
        <UltimasLiquidacionesProvider>
          <UltimasLiquidacionesPage />
        </UltimasLiquidacionesProvider>
      )}

      {reportType === 'rendicion-por-centro-de-costo' && (
        <Card className="mb-4">
          <Card.Title>Filtros</Card.Title>
          <Card.Body $padding>
            <RendicionPorCentroCostoFrom />
          </Card.Body>
        </Card>
      )}

      {reportType === 'movimientos-por-tarjeta' && (
        <Card className="mb-4">
          <Card.Title>Filtros</Card.Title>
          <Card.Body $padding>
            <MovimientosPorTarjetaForm />
          </Card.Body>
        </Card>
      )}

      {reportType === 'movimientos-liquidados' && (
        <Card className="mb-4">
          <Card.Title>Filtros</Card.Title>
          <Card.Body $padding>
            <MovimientosLiquidadosForm />
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};
